var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-alert',{attrs:{"variant":"danger","show":""}},[_vm._v("Page not found")])
}
var staticRenderFns = []

export { render, staticRenderFns }